module.exports = __webpack_public_path__ + "img/platipus.e6b397bf.svg";